module.exports = __webpack_public_path__ + "static/media/desktop_home_ic_weibo@2x.4b07c5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/live/assets/desktop_home_ic_weibo@2x.png
// module id = 1117
// module chunks = 0